import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { usePricing } from '../contexts/PricingContext';
import { ContactFormPopup } from './ContactFormPopup';
export function HeroVariant12() {
  const {
    t
  } = useLanguage();
  const {
    price
  } = usePricing();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [years, setYears] = useState(1);
  const traditionalCost = 1000 + 50 * 12 * years;
  const ourCost = 0 + 15 * 12 * years;
  const savings = traditionalCost - ourCost;
  return <>
      <section className="relative min-h-screen w-full overflow-hidden pt-32 pb-20 flex items-center" style={{
      backgroundColor: 'var(--bg-primary)'
    }} data-id="element-367">
        <div className="relative z-10 mx-auto flex w-full max-w-7xl flex-col lg:flex-row items-center justify-between gap-12 px-4" data-id="element-368">
          <div className="w-full lg:w-1/2 text-left flex flex-col items-start" data-id="element-369">
            <h1 className="mb-6 text-4xl md:text-5xl lg:text-[3.5rem] font-bold leading-tight text-gray-900" data-id="element-370">
              Сайт{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-purple-600" data-id="element-371">
                БЕСПЛАТНО.
              </span>
              <br data-id="element-372" />
              Платишь только {price}/мес.
            </h1>
            <p className="text-lg md:text-xl mb-8 text-gray-600 font-medium" data-id="element-373">
              Сначала макет — потом решение. Не понравится — уходишь без оплаты.
            </p>
            <button onClick={() => setIsPopupOpen(true)} className="group relative flex items-center justify-center gap-2 rounded-2xl px-8 py-4 font-bold text-lg transition-all hover:scale-105 overflow-hidden w-full sm:w-auto" style={{
            backgroundColor: 'var(--accent)',
            color: '#FFFFFF'
          }} data-id="element-374">
              Получить бесплатный макет
              <ArrowRightIcon className="w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-375" />
            </button>
          </div>

          {/* Right Column - Calculator */}
          <div className="w-full lg:w-1/2 relative mt-12 lg:mt-0" data-id="element-376">
            <div className="bg-white rounded-3xl p-8 shadow-2xl border border-gray-100" data-id="element-377">
              <h3 className="text-2xl font-bold mb-6 text-center" data-id="element-378">
                Калькулятор выгоды
              </h3>

              <div className="mb-8" data-id="element-379">
                <div className="flex justify-between mb-2" data-id="element-380">
                  <span className="font-medium text-gray-600" data-id="element-381">
                    Срок работы сайта
                  </span>
                  <span className="font-bold text-[var(--accent)]" data-id="element-382">
                    {years} {years === 1 ? 'год' : 'года'}
                  </span>
                </div>
                <input type="range" min="1" max="5" value={years} onChange={e => setYears(parseInt(e.target.value))} className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-blue-600" data-id="element-383" />
                <div className="flex justify-between text-xs text-gray-400 mt-2" data-id="element-384">
                  <span data-id="element-385">1 год</span>
                  <span data-id="element-386">5 лет</span>
                </div>
              </div>

              <div className="space-y-4 mb-8" data-id="element-387">
                <div className="flex justify-between items-center p-4 bg-gray-50 rounded-xl" data-id="element-388">
                  <div data-id="element-389">
                    <div className="font-semibold text-gray-500" data-id="element-390">
                      Обычная студия
                    </div>
                    <div className="text-xs text-gray-400" data-id="element-391">
                      Разработка $1000 + $50/мес
                    </div>
                  </div>
                  <div className="text-xl font-bold text-gray-400 line-through" data-id="element-392">
                    ${traditionalCost}
                  </div>
                </div>
                <div className="flex justify-between items-center p-4 bg-blue-50 rounded-xl border border-blue-100" data-id="element-393">
                  <div data-id="element-394">
                    <div className="font-bold text-blue-900" data-id="element-395">
                      С нами (Jetly)
                    </div>
                    <div className="text-xs text-blue-600" data-id="element-396">
                      Разработка $0 + $15/мес
                    </div>
                  </div>
                  <div className="text-2xl font-black text-blue-600" data-id="element-397">
                    ${ourCost}
                  </div>
                </div>
              </div>

              <div className="text-center p-4 bg-green-500 rounded-xl text-white" data-id="element-398">
                <div className="text-sm font-medium opacity-90 uppercase tracking-wider" data-id="element-399">
                  Ваша экономия
                </div>
                <div className="text-4xl font-black" data-id="element-400">${savings}</div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <ContactFormPopup isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} data-id="element-401" />
    </>;
}